import { VATRatePerCountry } from "./VATRatePerCountry";
type TemuShippingPolicy = {
  price: {
    totalAmount: number;
    amountWithoutVAT: number;
    amountVAT: number;
  };
  freeAbovePrice: number;
}

function getFieldsWithoutVAT(amountWithVAT: number, country: string) {
  return {
    totalAmount: amountWithVAT,
    amountWithoutVAT: VATRatePerCountry[country].reverseCoeff.times(amountWithVAT).round(2).toNumber(),
    amountVAT: VATRatePerCountry[country].reverseExtractCoeff.times(amountWithVAT).round(2).toNumber(),
  }
}

export const temuShippingPolicyPerCountry: Record<string, TemuShippingPolicy> = {
  FR: {
    price: getFieldsWithoutVAT(2.99, 'FR'),
    freeAbovePrice: 30,
  },
  DE: {
    price: getFieldsWithoutVAT(2.99, 'DE'),
    freeAbovePrice: 30,
  },
  IT: {
    price: getFieldsWithoutVAT(2.99, 'IT'),
    freeAbovePrice: 30,
  },
  NL: {
    price: getFieldsWithoutVAT(2.99, 'NL'),
    freeAbovePrice: 20,
  },
  ES: {
    price: getFieldsWithoutVAT(2.99, 'ES'),
    freeAbovePrice: 30,
  },
  PT: {
    price: getFieldsWithoutVAT(2.99, 'PT'),
    freeAbovePrice: 30,
  },
  IE: {
    price: getFieldsWithoutVAT(7.09, 'IE'),
    freeAbovePrice: 41.44,
  },
  BE: {
    price: getFieldsWithoutVAT(2.49, 'BE'),
    freeAbovePrice: 20,
  },
  AT: {
    price: getFieldsWithoutVAT(3.99, 'AT'),
    freeAbovePrice: 30,
  },
}